import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
import { FileGalleryCard } from "~/components/Gallery/FileGalleryCard/FileGalleryCard";
import { KANBAN_ITEM_CARD_WIDTH } from "~/components/KanbanView/shared/kanbanConstants";
import { DndSortableKanbanItem } from "./DndSortableKanbanItem";
const _KanbanFileComponent = (param)=>{
    let { dndDisabled, kanbanDndItemData, style, cardHeight, ...rest } = param;
    return /*#__PURE__*/ _jsx(DndSortableKanbanItem, {
        style: style,
        id: kanbanDndItemData.sortableKanbanItemKey,
        data: kanbanDndItemData,
        dndDisabled: dndDisabled,
        children: /*#__PURE__*/ _jsx("div", {
            className: "relative",
            style: {
                height: cardHeight
            },
            children: /*#__PURE__*/ _jsx(FileGalleryCard, {
                cardWidth: KANBAN_ITEM_CARD_WIDTH,
                getButtonClassName: ()=>"bg-grey-1 dark:border dark:border-grey-4 shadow-md cursor-pointer shadow-[0_1px_8px_rgba(0,0,0,0.1),0_0_2px_rgba(0,0,0,0.15)]",
                cardHeight: cardHeight,
                ...rest
            })
        })
    });
};
export const KanbanFileComponent = /*#__PURE__*/ memo(_KanbanFileComponent);
